module.exports = __webpack_public_path__ + "media/images/area/feature/okinawa/banner/ko-f8520241ebd1a0d869a96d24b545e8aa.jpg";